import React from 'react';
import "./styles.css"

/*
 * size and iconOnly are the sheets' five sizes. They are opt-in: leave them off
 * and the button keeps the height its caller asks for, which is how every
 * button in the app is written today. Passing height alongside size still wins,
 * so a caller can take a standard size and stretch it.
 */
const BlueButton = ({
                        disabled,
                        loading = false,
                        children,
                        onClick,
                        width = '100%',
                        height = null,
                        size = null,
                        iconOnly = false,
                        type = 'submit',
                        variant = 'default',
                        styles = {},
                        className = ''
                    }) => {


    let classes = className + ' ds-button blue-button';

    if (size) {
        classes += ' ds-button--' + size;
    }

    if (iconOnly) {
        classes += ' ds-button--icon';
    }

    if(variant === 'ghost') {
        classes += ' blue-button-ghost';
    }

    if(variant === 'outline') {
        classes += ' blue-button-outline';
    }

    if (variant === 'soft') {
        classes += ' blue-button-soft';
    }

    return (
        <button
            disabled={disabled || loading}
            type={type}
            className={classes}
            style={{
                width,
                height: height || (size ? undefined : '50px'),
                ...styles
            }}
            onClick={onClick}
        >
                {loading && <span className="ds-button__spinner"/>}
                {children}
        </button>
    );
};

export default BlueButton;



// WEBPACK FOOTER //
// ./src/components-new/buttons/BlueButton/index.jsx